<template>
    <div class="mt-3">
        <h5>Pengumuman</h5>

        <div v-for="data, index in pengumuman" :key="index" class="accordion" role="tablist">
            <b-alert show variant="info" class="p-2 mb-1" v-b-toggle="'accordion-' + index">{{ data.PengumumanJudul }}</b-alert>
            <b-collapse :id="'accordion-' + index" :visible="index == 0 ? true : false" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <b-card-text>{{ data.PengumumanIsi }}</b-card-text>
                </b-card-body>
            </b-collapse>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pengumuman: []
        }
    },
    created() {
        this.getPengumuman()
    },
    methods: {
        getPengumuman() {
            this.$isLoading(true)
            let uri = '/api/pengumuman?status=1'

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.pengumuman = response.data.pengumuman
                }
                this.$isLoading(false)
            })
        }
    }
}
</script>